(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaLabelController', ['$rootScope', 'Alert', 'AgendaLabelService', 'AgendaLabel', '$uibModal', 'HelperService', 'RoleType', AgendaLabelControllerFn]);

    /* controlle for agenda label directive */
    function AgendaLabelControllerFn($rootScope, Alert, AgendaLabelService, AgendaLabel, $uibModal, HelperService, RoleType) {
        var vm = this;
        vm.restrictedRolesString = '';
        vm.isRingfoonAdmin = false;
        vm.isRingfoon = false;

        activate();

        // edit agenda label -> open modal
        vm.edit = showEditModal;

        function showEditModal() {

            if (vm.label.isNoApppointmentPossibleLabel && !vm.isRingfoonAdmin) { return; }

            // modal 
            var modalInstance = null;

            // open modal
            modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/agendasettings/modules/agendalabels/templates/agenda-label-details.template.html',
                controller: 'DetailAgendaLabelController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    label: ['AgendaLabelService', function (AgendaLabelService) {
                        return AgendaLabelService.get(vm.label.id).then(function (result) {
                            var item = new AgendaLabel();
                            item.extend(result);
                            return item;
                        });
                    }],
                    colors: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.colors();
                    }],
                    languages: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.languages();
                    }],
                    roles: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.labelRoles();
                    }]
                }
            });

            // when modal is closed
            modalInstance.result.then(function (updatedLabel) {                
                vm.label = updatedLabel;
                vm.overview.replace(updatedLabel);
                createRestrictedRoleString();
            }, function (result) {
                //dismissed
                if (result === 'reload') {
                    // wrong user inputs -> reload modal
                    showEditModal();
                }
            });
        };

        // deactivate agenda label
        vm.deactivate = function () {
            AgendaLabelService.deactivate(vm.label.id).then(function (result) {
                vm.overview.remove(vm.label);
                Alert.success("Label was successfully deactivated");
            });
        };


        /* activation work */
        function activate() {
            createRestrictedRoleString();
            vm.isRingfoonAdmin = $rootScope.isRingfoonAdmin;
            vm.isRingfoon = $rootScope.isRingfoon;
        }

        // translate the agendaroles to the current language and create a comma-separated string
        function createRestrictedRoleString() {
            var roles = [];
            vm.label.restrictedRoles.forEach(function (item) {
                if (item.deleted === false)
                    roles.push(item.role);
            });

            HelperService.translateRoles(roles).then(function (result) {
                vm.restrictedRolesString = result.join(',');
            });
        }
    }
})();
